import { getCountries } from '../../../../../actions/common/countries';
import { getIndustries } from '../../../../../actions/common/industries';
import { setPicture, setPictureUI } from './picture';
import { setSummary } from './summary';
import { setLocations } from './locations';
import { setHeadline } from './headline';
import { setIndustries } from './industry';
import { setName } from './name';
import { setExperience } from './experience';
import { setEducation } from './education';
import { setCertificates } from './certificates';
import { setPress } from './press';
import { setAwards } from './awards';
import { setPublications } from './publications';
import { setEndorsements } from './endorsements';
import { setForms, showForm } from './forms';
import { setVisibility } from './visibility';
import { setGuestMode } from './guest';
import { setExpertise } from './expertise';
import { setMarkets } from './markets';
import { setSectors } from './sectors';
import { getUserPermissions} from './permissions';
import { setInvestments, getInvestmentsList } from './investments';
import { setRating } from './rating';

export {
    setHeadline,
    setLocations,
    setSummary,
    setPicture,
    setPictureUI,
    setName,
    setExperience,
    setEducation,
    setCertificates,
    setPress,
    getCountries,
    getIndustries,
    setAwards,
    setPublications,
    setEndorsements,
    setIndustries,
    setForms,
    showForm,
    setVisibility,
    setGuestMode,
    setExpertise,
    setMarkets,
    setSectors,
    getUserPermissions,
    setInvestments,
    getInvestmentsList,
    setRating,
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/setters.js